import { EventsConfig } from '@chart/types/events.types';

export const isAssetEnabled = ({
  tag,
  eventsConfig,
}: {
  tag: string;
  eventsConfig: EventsConfig;
}): boolean => {
  if (!eventsConfig.TMI) {
    return false;
  }

  if (!eventsConfig.INSIGHTS) {
    return true;
  }

  return eventsConfig.INSIGHTS[tag] ?? false;
};

export const areAnyAssetsEnabled = ({
  uniqueAssets,
  eventsConfig,
}: {
  uniqueAssets: { tag: string }[];
  eventsConfig: EventsConfig;
}): boolean =>
  uniqueAssets.some(asset => isAssetEnabled({ tag: asset.tag, eventsConfig }));

export const handleAllInsightsToggle = ({
  checked,
  uniqueAssets,
  eventsConfig,
  onChange,
}: {
  checked: boolean;
  uniqueAssets: { tag: string }[];
  eventsConfig: EventsConfig;
  onChange: (config: EventsConfig) => void;
}) => {
  const newInsights: Record<string, boolean> = {};
  uniqueAssets.forEach(asset => {
    newInsights[asset.tag] = checked;
  });

  onChange({
    ...eventsConfig,
    TMI: checked,
    INSIGHTS: newInsights,
  });
};

export const handleAssetToggle = ({
  tag,
  checked,
  eventsConfig,
  uniqueAssets,
  onChange,
}: {
  tag: string;
  checked: boolean;
  eventsConfig: EventsConfig;
  uniqueAssets: { tag: string }[];
  onChange: (config: EventsConfig) => void;
}) => {
  const currentInsights =
    eventsConfig.INSIGHTS ??
    Object.fromEntries(uniqueAssets.map(a => [a.tag, true]));

  const newInsights: Record<string, boolean> = {};
  uniqueAssets.forEach(asset => {
    newInsights[asset.tag] =
      asset.tag === tag ? checked : (currentInsights[asset.tag] ?? false);
  });

  onChange({
    ...eventsConfig,
    TMI: Object.values(newInsights).some(Boolean),
    INSIGHTS: newInsights,
  });
};
